import { render, staticRenderFns } from "./ExtrahealthLandingPage.vue?vue&type=template&id=2e25292d&scoped=true"
import script from "./ExtrahealthLandingPage.vue?vue&type=script&lang=js"
export * from "./ExtrahealthLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e25292d",
  null
  
)

export default component.exports